export enum TaskCodes {
  TaskCodeCustomization = 'customization',
  TaskCodeFirstClient = 'firstClient',
  TaskCodeFirstApp = 'firstApp',
  TaskCodeCustomDomain = 'customDomain',
  TaskCodeSetupWithPayments = 'setupPayments',
}
